import * as React from "react";
import QuoteItem from "../../../model/quote/QuoteItem";
import ItemQuantityPicker from "./ItemQuantityPicker";

interface ComponentProps {
	/**
	 * Quote items
	 */
	items: QuoteItem[];
	/**
	 * On remove function
	 * @param item
	 */
	onRemove: (item: QuoteItem) => void;
	/**
	 * On change function
	 * @param item
	 */
	onChange: (item: QuoteItem) => void;
	/**
	 * Vat
	 */
	vat: number;
}

export default class QuoteItemList extends React.PureComponent<ComponentProps, {}> {
	render() {
		return (
			<React.Fragment>
				{this.props.items.map(item =>
					<ItemQuantityPicker key={item.assetId}
										name={item.name}
										price={item.getTotalPrice()}
										quantity={item.quantity}
										onRemove={() => {this.props.onRemove(item)}}
										onDecrementClick={() => {this.onDecrementClick(item)}}
										onIncrementClick={() => {this.onIncrementClick(item)}}/>
				)}
			</React.Fragment>
		)
	}

	onDecrementClick(item: QuoteItem) {
		if (item.quantity - 1 > 0) {
			this.props.onChange(item.withNewQuantity(item.quantity - 1, this.props.vat))
		}
	}

	onIncrementClick(item: QuoteItem) {
		this.props.onChange(item.withNewQuantity(item.quantity + 1, this.props.vat))
	}
}